export default "__VITE_ASSET__ENaZYNYe__"